import {Component, OnInit} from '@angular/core';
import {InactivityService} from './service/inactivity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ssid-public';

  constructor(private inactivityService : InactivityService) {
  }

  ngOnInit() {
    console.log('inactive service activated!');
  }
}
